import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../../../chunks/tslib.es6.js";
import e from "../../../core/Evented.js";
import { HandleOwner as i } from "../../../core/HandleOwner.js";
import { isSome as n } from "../../../core/maybe.js";
import { isAborted as s } from "../../../core/promiseUtils.js";
import { react as o, sync as r, syncAndInitial as a } from "../../../core/reactiveUtils.js";
import { property as d } from "../../../core/accessorSupport/decorators/property.js";
import "../../../core/arrayUtils.js";
import "../../../core/has.js";
import "../../../core/accessorSupport/ensureType.js";
import { subclass as c } from "../../../core/accessorSupport/decorators/subclass.js";
import { a as h } from "../../../chunks/vec2.js";
import p from "../../../geometry/SpatialReference.js";
import { FeatureSnappingEngine as l } from "./FeatureSnappingEngine.js";
import { SelfSnappingEngine as u } from "./SelfSnappingEngine.js";
import f from "./SnappingOptions.js";
import { squareDistance as v, anyMapPointToScreenPoint as m, sortCandidatesInPlace as g } from "./snappingUtils.js";
import { IntersectionSnappingCandidate as y } from "./candidates/IntersectionSnappingCandidate.js";

var C = /*#__PURE__*/function (_e$EventedMixin) {
  _inherits(C, _e$EventedMixin);

  var _super = _createSuper(C);

  function C(t) {
    var _this;

    _classCallCheck(this, C);

    _this = _super.call(this, t), _this.options = new f(), _this.engines = [], _this._currentMainCandidate = null, _this._currentOtherActiveCandidates = [];
    return _this;
  }

  _createClass(C, [{
    key: "initialize",
    value: function initialize() {
      var _this2 = this;

      this.handles.add([o(function () {
        var _this2$options = _this2.options,
            t = _this2$options.effectiveFeatureEnabled,
            e = _this2$options.effectiveSelfEnabled,
            i = _this2$options.touchSensitivityMultiplier,
            n = _this2$options.distance;
        return {
          effectiveFeatureEnabled: t,
          effectiveSelfEnabled: e,
          touchSensitivityMultiplier: i,
          distance: n
        };
      }, function () {
        _this2.doneSnapping(), _this2.emit("changed");
      }, r), o(function () {
        return _this2.options;
      }, function (t) {
        var _iterator = _createForOfIteratorHelper(_this2.engines),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _e = _step.value;
            _e.options = t;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }, r), o(function () {
        return _this2.view.ready;
      }, function (t) {
        return _this2.onViewReady(t);
      }, a)]);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.destroyEngines();
    }
  }, {
    key: "updating",
    get: function get() {
      return this.engines.some(function (t) {
        return t.updating;
      });
    }
  }, {
    key: "onViewReady",
    value: function onViewReady(t) {
      var e, i;
      (this.destroyEngines(), t) && (this.engines = [new u({
        view: this.view,
        options: this.options
      }), new l({
        view: this.view,
        spatialReference: null != (e = null == (i = this.view) ? void 0 : i.spatialReference) ? e : p.WGS84,
        options: this.options
      })]);
    }
  }, {
    key: "destroyEngines",
    value: function destroyEngines() {
      var _iterator2 = _createForOfIteratorHelper(this.engines),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _t = _step2.value;

          _t.destroy();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this.engines.length = 0;
    }
  }, {
    key: "squaredMouseProximityTreshold",
    get: function get() {
      return this.options.distance * this.options.distance;
    }
  }, {
    key: "squaredTouchProximityThreshold",
    get: function get() {
      var _this$options = this.options,
          t = _this$options.distance,
          e = _this$options.touchSensitivityMultiplier,
          i = t * e;
      return i * i;
    }
  }, {
    key: "snap",
    value: function () {
      var _snap = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t, e, i) {
        var _this3 = this;

        var o, r;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                o = e.coordinateHelper.pointToVector(t);
                _context.next = 3;
                return this.fetchCandidates(o, e, i);

              case 3:
                r = _context.sent;

                _context.t0 = function apply() {
                  var _this3$processCandida = _this3.processCandidates(o, r, e),
                      t = _this3$processCandida.snappedPoint,
                      i = _this3$processCandida.hints;

                  return _this3.removeVisualization(), n(e.visualizer) && _this3.handles.add(e.visualizer.draw(i, {
                    coordinateHelper: e.coordinateHelper,
                    elevationInfo: e.elevationInfo,
                    view: _this3.view
                  }), w), t;
                };

                return _context.abrupt("return", {
                  get valid() {
                    return !s(i);
                  },

                  apply: _context.t0
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function snap(_x, _x2, _x3) {
        return _snap.apply(this, arguments);
      }

      return snap;
    }()
  }, {
    key: "update",
    value: function update(t, e) {
      this.removeVisualization();
      var i = t;
      var s = [];

      if (n(this._currentMainCandidate)) {
        var _n = e.coordinateHelper,
            _o = _n.pointToVector(t),
            _r = this._currentMainCandidate.constraint.closestTo(_o);

        if (v(m(_o, _n, e.elevationInfo, this.view), m(_r, _n, e.elevationInfo, this.view)) < this.squaredPointProximityThreshold(e.pointer)) {
          i = _n.vectorToDehydratedPoint(_r), this._currentMainCandidate.targetPoint = _r, s.push.apply(s, _toConsumableArray(this._currentMainCandidate.hints));

          var _iterator3 = _createForOfIteratorHelper(this._currentOtherActiveCandidates),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _t2 = _step3.value;
              _t2.targetPoint = _r, s.push.apply(s, _toConsumableArray(_t2.hints));
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        } else this._currentMainCandidate = null, this._currentOtherActiveCandidates = [];
      }

      return n(e.visualizer) && this.handles.add(e.visualizer.draw(s, {
        coordinateHelper: e.coordinateHelper,
        elevationInfo: e.elevationInfo,
        view: this.view
      }), w), i;
    }
  }, {
    key: "doneSnapping",
    value: function doneSnapping() {
      this.removeVisualization(), this._currentMainCandidate = null, this._currentOtherActiveCandidates = [];
    }
  }, {
    key: "removeVisualization",
    value: function removeVisualization() {
      this.handles.remove(w);
    }
  }, {
    key: "fetchCandidates",
    value: function () {
      var _fetchCandidates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t, e, i) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Promise.all(this.engines.map(function (n) {
                  return n.fetchCandidates(t, e, i);
                }));

              case 2:
                return _context2.abrupt("return", _context2.sent.flat());

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchCandidates(_x4, _x5, _x6) {
        return _fetchCandidates.apply(this, arguments);
      }

      return fetchCandidates;
    }()
  }, {
    key: "processCandidates",
    value: function processCandidates(t, e, i) {
      if (e.length < 1) return this.doneSnapping(), {
        snappedPoint: i.coordinateHelper.vectorToDehydratedPoint(t),
        hints: []
      };
      g(t, e);
      var s = this._currentMainCandidate;

      if (n(s)) {
        var _n2 = this.findOldConstraintInNewCandidates(s, e);

        if (_n2 >= 0) {
          if (!(e[_n2] instanceof y)) return this.intersectWithOtherCandidates(_n2, e, t, i);
          if (h(t, s.targetPoint) < this.squaredPointProximityThreshold(i.pointer)) return this.updateSnappingCandidate(s, e, i);
        }
      }

      return this.intersectWithOtherCandidates(0, e, t, i);
    }
  }, {
    key: "findOldConstraintInNewCandidates",
    value: function findOldConstraintInNewCandidates(t, e) {
      return t instanceof y ? this.findOldCandidateIndex(e, t.first) >= 0 && this.findOldCandidateIndex(e, t.second) >= 0 ? 0 : -1 : this.findOldCandidateIndex(e, t);
    }
  }, {
    key: "intersectWithOtherCandidates",
    value: function intersectWithOtherCandidates(t, e, i, n) {
      var s = e[t],
          o = [],
          r = n.coordinateHelper;

      for (var _a = 0; _a < e.length; ++_a) {
        if (_a === t) continue;
        var _d = e[_a];

        var _iterator4 = _createForOfIteratorHelper(s.constraint.intersect(_d.constraint)),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _t3 = _step4.value;

            var _e2 = r.fromXYZ(_t3.intersection, s.targetPoint[2]);

            o.push([new y(r, _e2, s, _d), v(m(i, n.coordinateHelper, n.elevationInfo, this.view), m(_e2, n.coordinateHelper, n.elevationInfo, this.view))]);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }

      return o.length > 0 && (o.sort(function (t, e) {
        return t[1] - e[1];
      }), o[0][1] < this.squaredPointProximityThreshold(n.pointer)) ? this.updateSnappingCandidate(o[0][0], e, n) : this.updateSnappingCandidate(s, e, n);
    }
  }, {
    key: "updateSnappingCandidate",
    value: function updateSnappingCandidate(t, e, i) {
      this.doneSnapping(), this._currentMainCandidate = t;
      var n = this._currentMainCandidate.targetPoint,
          s = [];
      s.push.apply(s, _toConsumableArray(t.hints));

      var _iterator5 = _createForOfIteratorHelper(e),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _o2 = _step5.value;

          if (t instanceof y) {
            if (_o2.constraint.objectEqual(t.first.constraint) || _o2.constraint.objectEqual(t.second.constraint)) continue;
          } else if (_o2.constraint.objectEqual(t.constraint)) continue;

          _o2.constraint.check(n) && (_o2.targetPoint = n, this._currentOtherActiveCandidates.push(_o2), s.push.apply(s, _toConsumableArray(_o2.hints)));
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return {
        snappedPoint: i.coordinateHelper.vectorToDehydratedPoint(n),
        hints: s
      };
    }
  }, {
    key: "squaredPointProximityThreshold",
    value: function squaredPointProximityThreshold(t) {
      return "touch" === t ? this.squaredTouchProximityThreshold : this.squaredMouseProximityTreshold;
    }
  }, {
    key: "findOldCandidateIndex",
    value: function findOldCandidateIndex(t, e) {
      var i = -1;

      for (var _n3 = 0; _n3 < t.length; ++_n3) {
        if (e.constraint.objectEqual(t[_n3].constraint)) {
          i = _n3;
          break;
        }
      }

      return i;
    }
  }, {
    key: "test",
    get: function get() {
      return {
        visualizationsActive: this.handles.has(w),
        engines: this.engines
      };
    }
  }]);

  return C;
}(e.EventedMixin(i));

t([d({
  constructOnly: !0
})], C.prototype, "view", void 0), t([d()], C.prototype, "options", void 0), t([d({
  readOnly: !0
})], C.prototype, "updating", null), t([d()], C.prototype, "engines", void 0), t([d()], C.prototype, "squaredMouseProximityTreshold", null), t([d()], C.prototype, "squaredTouchProximityThreshold", null), C = t([c("esri.views.interactive.snapping.SnappingManager")], C);
var w = "visualization-handle";
export { C as SnappingManager };